/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const form7Slice = createSlice({
  name: 'form7',
  initialState: {
    cardName: '',
    cardNumber: '',
    cardExpirationMonth: '',
    cardExpirationYear: '',
    cardCVV: '',
    termsAndPrivacy: false,
    termsAndConditons: false,
    termsAndConditonsInsurance: false,
    isPaid: false,
    isPolicyEmited: false,
  },
  reducers: {
    setFormData(state, { payload }) {
      state.cardName = payload.cardName;
      state.cardNumber = payload.cardNumber;
      state.cardExpirationMonth = payload.cardExpirationMonth;
      state.cardExpirationYear = payload.cardExpirationYear;
      state.cardCVV = payload.cardCVV;
      state.termsAndPrivacy = payload.termsAndPrivacy;
      state.termsAndConditons = payload.termsAndConditons;
      state.termsAndConditonsInsurance = payload.termsAndConditonsInsurance;
    },
    setIsPaid(state, { payload }) {
      state.isPaid = payload.isPaid;
    },
    setPolicyEmited(state, { payload }) {
      state.isPolicyEmited = payload.isPolicyEmited;
    },
  },
});

export const form7Actions = form7Slice.actions;

export default form7Slice;
/* eslint-enable no-param-reassign */
